import axios from "axios";
import { domain } from "../Links/Links";
export async function checkingUsername(username, setUsernameIsBeing) {
  const response = await axios.get(
    domain + "/checking_username/?username=" + username,
    {
      withCredentials: true,
    },
  );

  if (response.data.username_is_being) {
    setUsernameIsBeing(true);
  } else if (response.data.ok) {
    setUsernameIsBeing(false);
  }

  console.log(response.data);

  return response.data;
}
